<div class="pop-up-content" #popup>
<img src="/assets/material/icecream.svg" alt="" class="icon"/>
<h1 mat-dialog-title>פופ אפ מסך מלא</h1>
<span class="sub-title">כדאי לחזור לעמוד הקודם ולנסות שוב, אם הבעיה חוזרת אנחנו כאן</span>
<div class="button-wrapper">
  <a href="#" title="" class="brand-button aqua-button"><span>חזרה</span></a>
</div>
<div mat-dialog-actions>
  <button (click)="close()" class="close" mat-button mat-dialog-close>×</button>
</div>
</div>
